/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalSettings } from '../../models/global-settings';

export interface GlobalMappingSettingsFetch$Params {
  settingId?: number;
}

export function globalMappingSettingsFetch(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsFetch$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSettings>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsFetch.PATH, 'get');
  if (params) {
    rb.query('settingId', params.settingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalSettings>;
    })
  );
}

globalMappingSettingsFetch.PATH = '/globalsettings/fetch';
